import React from 'react';
import type { ScenarioLocation } from '../../lib/planningData';
import type { MultiKey } from '../core/MultiKey';

export type LocationPair = readonly [
  fromLocationId: number,
  toLocationId: number,
  avoidsChannels: boolean,
  draft: number | null,
  noGoZones: string,
];

export type RouteParams = [
  fromLong: number,
  fromLat: number,
  toLong: number,
  toLat: number,
  avoidsChannels: boolean,
  draft: number | null,
  noGoZones: string,
];

export type RouteData = {
  is_override: boolean;
  dist: number;
  inside_nm?: number;
  outside_nm?: number;
  used_channels?: string[];
};

export type LocationPairNullish = [
  fromLocationId: number,
  toLocationId: number,
  avoidsChannels: boolean,
  draft?: number | null,
  noGoZones?: string,
];

export type Distances = {
  get: (...pair: LocationPairNullish) => RouteData | undefined;
  set: (data: RouteData, ...pair: LocationPair) => void;
  map: MultiKey<RouteData, RouteParams>;
};

export interface DistanceContextProps {
  distances: Distances;
  noGoZones: string;
  queueDistancesForLocationPairs: (locationPairs: LocationPair[]) => void;
  queueAllDistancesBetweenLocations: (
    locationIds: Set<number | null | undefined>,
  ) => void;
  fetchMissingDistances: (
    existingDistances: Distances,
    locationIds: Set<number>,
    includeAvoidsChannels?: boolean,
  ) => Promise<Distances>;
  resetDistances: () => void;
  setLocations: (locations: Map<number, ScenarioLocation>) => void;
}

export const DistanceContext = React.createContext<
  DistanceContextProps | undefined
>(undefined);
